<div id="list-contacts" *ngIf="templateView==1">
    <h2 class="mt-5 font-weight-bolder"><i class="fa fa-shield-alt text-mid-dark font-size-h1"></i> {{ "GENERAL.CONTACTS" | translate }}</h2>

    <div class="card card-custom gutter-b mt-10">
        <div class="card-header d-none">
            <div class="card-title">
                <h3 class="card-label">{{ "GENERAL.CONTACTS" | translate }}</h3>
            </div>
        </div>
    </div>

    <div class="row">

        <div class="col-md-4" *ngFor="let item of contactService.items$ | async; let i = index ">
           <div class="card card-custom">
                <div class="card-body pt-0">
                    <div class="my-10">
                        <div class="d-fle x">
                            <div class="text-center">
                                <img alt="" src="./assets/media/people/{{ item.Logo }}" width="100" class=" rounded-lg">
                            </div>
                        </div>
                    </div>

                    <div class="mb-10 row">
                        <div class="col-12">
                            <div class="font-weight-bold font-size-lg mb-3 font-weight-bolder"><i class="fa fa-user"></i> <span class="pl-3">{{ item.Contacto }}</span></div>
                        </div>
                        <div class="col-12">
                            <div class="font-weight-bold font-size-lg mb-3 font-weight-bold"><i class="fa fa-shield-alt"></i> <span class="pl-3">{{ item.Ramo }}</span></div>
                        </div>
                        <div class="col-12">
                            <div class="font-weight-bold font-size-lg mb-3 font-weight-bold"><i class="fa fa-phone"></i> <span class="pl-3">{{ item.Telefono }}</span></div>
                        </div>
                        <div class="col-12">
                            <div class="font-weight-bold font-size-lg mb-3 font-weight-bold"><i class="fa fa-envelope"></i> <span class="pl-3"> {{item.Email }}</span></div>
                        </div>
                    </div>
                </div>
           </div>
        </div>

    </div>
</div>